import { Col, Row } from "antd";

interface RedeemCashProps {
  data: any;
}

const RedeemCash: React.FC<RedeemCashProps> = ({ data }) => {
  return (
    <div className="get-back">
      <Row gutter={[10, 16]}>
        <Col xs={12} md={12} lg={6}>
          <div className="text-holder">
            <h3 className="sub_title">NEW SIGNUPS</h3>
            <h1 className="title">{data?.shared ? data?.shared : "-"}</h1>
          </div>
        </Col>
        <Col xs={12} md={12} lg={6}>
          <div className="text-holder">
            <h3 className="sub_title">ACTIVE REFERRALS</h3>
            <h1 className="title">
              {data?.active_referrals ? data?.active_referrals : "-"}
            </h1>
          </div>
        </Col>
        <Col xs={12} md={12} lg={6}>
          <div className="text-holder">
            <h3 className="sub_title">PAYOUT EVERY $25</h3>
            <h1 className="title">
              {data?.pending_payout
                ? `$${data?.pending_payout?.toFixed(2)}`
                : "-"}
            </h1>
          </div>
        </Col>
        <Col xs={12} md={12} lg={6}>
          <div className="text-holder">
            <h3 className="sub_title">REDEEMED</h3>
            <h1 className="title">
              {data?.redeemed ? `$${data?.redeemed?.toFixed(2)}` : "-"}
            </h1>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RedeemCash;
